import { render, staticRenderFns } from "./MaterialGroup.vue?vue&type=template&id=b01404aa&scoped=true"
import script from "./MaterialGroup.vue?vue&type=script&lang=js"
export * from "./MaterialGroup.vue?vue&type=script&lang=js"
import style0 from "./MaterialGroup.vue?vue&type=style&index=0&id=b01404aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01404aa",
  null
  
)

export default component.exports